module.exports = __webpack_public_path__ + "static/media/gamestart.634a8ea.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/gamestart.wav
// module id = 153
// module chunks = 1